import { 
  Component, 
  OnInit,
  OnChanges,
  Input,
  SimpleChanges, 
  EventEmitter,
  Output,
  Inject
} from '@angular/core';

import { FatNumberStyles } from './models/widget';
import { isNil } from 'lodash-es';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { TransloadOrders_ShellService } from './TransloadOrders.shell.service';
import { TransloadOrders_OperationService } from './TransloadOrders.operation.service';
import { TransloadOrders_DatasourceService } from './TransloadOrders.datasource.index';
import { TransloadOrders_FlowService } from './TransloadOrders.flow.index';
import { TransloadOrders_ReportService } from './TransloadOrders.report.index';
import { TransloadOrders_LocalizationService } from './TransloadOrders.localization.service';
import { TransloadOrders_order_total_received_gross_by_date_widget_ComponentContextService } from './TransloadOrders.order_total_received_gross_by_date_widget.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './TransloadOrders.frontend.types'
import { $frontendTypes as $types} from './TransloadOrders.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'TransloadOrders-order_total_received_gross_by_date_widget',
  templateUrl: './TransloadOrders.order_total_received_gross_by_date_widget.component.html'
})
export class TransloadOrders_order_total_received_gross_by_date_widgetComponent extends BaseComponent implements OnInit, OnChanges {
  //#region Outputs
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  inParams: { date: string, ownerId?: number, projectId?: number, warehouseId?: number, orderStatusIds?: number[] } = { date: null, ownerId: null, projectId: null, warehouseId: null, orderStatusIds: [] };
  //#region Inputs
  @Input('date') set $inParams_date(v: string) {
    this.inParams.date = v;
  }
  get $inParams_date(): string {
    return this.inParams.date;
  }
  @Input('ownerId') set $inParams_ownerId(v: number) {
    this.inParams.ownerId = v;
  }
  get $inParams_ownerId(): number {
    return this.inParams.ownerId;
  }
  @Input('projectId') set $inParams_projectId(v: number) {
    this.inParams.projectId = v;
  }
  get $inParams_projectId(): number {
    return this.inParams.projectId;
  }
  @Input('warehouseId') set $inParams_warehouseId(v: number) {
    this.inParams.warehouseId = v;
  }
  get $inParams_warehouseId(): number {
    return this.inParams.warehouseId;
  }
  @Input('orderStatusIds') set $inParams_orderStatusIds(v: number[]) {
    this.inParams.orderStatusIds = v;
  }
  get $inParams_orderStatusIds(): number[] {
    return this.inParams.orderStatusIds;
  }
  //#endregion Inputs

  //#region Variables
  //#endregion  
  private entity: { TotalGross?: number };

  value: any;
  styles: FatNumberStyles;
  originalValue: any;
  prefix: string = '';
  suffix: string = '';

  constructor(private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: TransloadOrders_ShellService,
private $datasources: TransloadOrders_DatasourceService,
private $flows: TransloadOrders_FlowService,
private $reports: TransloadOrders_ReportService,
private $localization: TransloadOrders_LocalizationService,
private $operations: TransloadOrders_OperationService,
private $logger: CleanupLoggerService,
private $context: TransloadOrders_order_total_received_gross_by_date_widget_ComponentContextService,
) { 
    super();

    this.styles = new FatNumberStyles();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.date)) {
        this.$missingRequiredInParams.push('date');
      }
  }

  initialized = false;
  $hasDataLoaded = false;

  async $init() {

    await this.$dataLoad();

    this.initialized = true;
  }
  
  async $dataLoad() {
    const $widget = this;
    const $utils = this.$utils;

    const dsParams = {
      date:  $widget.inParams.date ,
      ownerId:  $widget.inParams.ownerId ,
      projectId:  $widget.inParams.projectId ,
      warehouseId:  $widget.inParams.warehouseId ,
      orderStatusIds:  $widget.inParams.orderStatusIds 
    };

    const data = await this.$datasources.TransloadOrders.ds_order_total_received_gross_by_date_widget.get(dsParams);
    if (isNil(data.result)) {
      this.$hasDataLoaded = false;
      this.entity = null;
    } else {
      this.$hasDataLoaded = true;
      this.entity = data.result;
      await this.$dataLoaded();
    }
  }

  async $dataLoaded() {
    const $widget = this;
    const $utils = this.$utils;

    this.value = $utils.isDefined($widget.entity.TotalGross) ? $widget.entity.TotalGross : 0;

    
    this.originalValue = $utils.isDefined($widget.entity.TotalGross) ? $widget.entity.TotalGross : 0;
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  getStyleClass() {
    const valString = isNil(this.value) ? '' : this.value.toString();
    const length = (valString).length;
    if (length === 2) {
      return 'tens';
    }
    if (length === 3) {
      return 'hundreds';
    }
    if (length === 4) {
      return 'thousands';
    }
    if (length === 5) {
      return 'tenThousands';
    }
    if (length === 6) {
      return 'hundredThousands';
    }
    if (length > 6) {
      return 'millions';
    }
    return null;
  }

}
